import { render, staticRenderFns } from "./MenuSite.vue?vue&type=template&id=fba81816&scoped=true"
import script from "./MenuSite.vue?vue&type=script&lang=js"
export * from "./MenuSite.vue?vue&type=script&lang=js"
import style0 from "./MenuSite.vue?vue&type=style&index=0&id=fba81816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba81816",
  null
  
)

export default component.exports